import { useEffect } from 'react';

export const APP_REFRESH_EVENT = 'app:refresh';

/**
 * Subscribe to app-level refresh requests (pull-to-refresh, etc).
 * Pages pass a callback that re-fetches their data. Much cheaper than
 * a full window.location.reload() — keeps the React tree, in-memory
 * access token, React Router state and React Query cache intact.
 */
export function useAppRefresh(callback: () => void | Promise<void>) {
  useEffect(() => {
    const handler = () => { void callback(); };
    window.addEventListener(APP_REFRESH_EVENT, handler);
    return () => window.removeEventListener(APP_REFRESH_EVENT, handler);
  }, [callback]);
}

/** Programmatically trigger an app refresh (used by PullToRefresh). */
export function triggerAppRefresh() {
  window.dispatchEvent(new CustomEvent(APP_REFRESH_EVENT));
}
